_ = require 'underscore'
Auth = require 'app/scripts/db/auth'
limitErrorPopover = require 'app/scripts/views/lib/limit-error-popover'

trackingArea = "Member Limits"
maybeDisplayMemberLimitsError = (elem, board, member) ->
  m = if board?.isOverLimit('boards', 'totalMembersPerBoard')
      message: 'members exceeds total per board limit'
      params: { boardName: board.get("name") }
    else if member?.isOverLimit('boards', 'totalPerMember')
      if Auth.isMe(member)
        message: 'your boards exceed total per member limit'
      else
        message: 'boards exceeds total per member limit'
        params: { memberName: member.get("name") }

  if m?
    limitErrorPopover(_.extend({ trackingArea, elem }, m))
    return true
  return false

module.exports = { maybeDisplayMemberLimitsError }
